import React from 'react';
import { EditTranscriptContextType } from './types';

export const EditTranscriptContext = React.createContext<
  EditTranscriptContextType | undefined
>(undefined);
